import React from "react";

// Real Nuvun mark — uses official PNG assets supplied by the brand.
export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/images/nuvun/logo-icon.png"
    alt="Nuvun mark"
    width={size}
    height={size}
    className={className}
    style={{ display: "block", width: size, height: size, objectFit: "contain" }}
  />
);

// Full wordmark — auto-swaps between light (white text) and dark (charcoal text) variants.
export const Logo = ({ inverted = false, height = 36, className = "" }) => {
  const src = inverted ? "/images/nuvun/logo-light.png" : "/images/nuvun/logo-dark.png";
  // wordmark is 1976 x 418 → ratio ~4.73
  const width = Math.round(height * (1976 / 418));
  return (
    <img
      src={src}
      alt="Nuvun"
      width={width}
      height={height}
      data-testid="nuvun-logo"
      className={className}
      style={{ display: "block", width, height, objectFit: "contain" }}
    />
  );
};

export default Logo;
